import { useParams } from "react-router-dom";
import { getAuthCookie, unauthenticatedLoginPath } from "../utils/authCookies";

function reportPathForLicense(licenseType: string, reportId: string): string {
  const license = String(licenseType || "").trim().toUpperCase().replace(/[\s-]+/g, "_");
  let prefix = "/realtor";
  if (
    license === "BROKERAGE_TEAM_MEMBER" ||
    license === "TEAM_MEMBER" ||
    license === "TEAMMEMBER" ||
    license === "BROKERAGE_TEAMMEMBER"
  ) {
    prefix = "/teammember";
  } else if (license === "AGENT" || license === "BROKERAGE_AGENT") {
    prefix = "/agent";
  } else if (license === "SIGNAGE_TEAM_MEMBER" || license === "SIGNAGE_TEAMMEMBER") {
    prefix = "/signageteammember";
  } else if (license === "SIGNAGE_FIRM" || license === "SIGNAGE") {
    prefix = "/signage";
  }
  return `${prefix}/batchPaymentReport/${reportId}`;
}

export default function UsersBatchPaymentReportRedirect() {
  const { reportId } = useParams<{ reportId: string }>();
  const id = String(reportId || "").trim();
  const token = getAuthCookie("sessionToken")?.trim();
  const target = !id
    ? "/login"
    : !token
      ? unauthenticatedLoginPath(`/users/batchPaymentReport/${id}`)
      : reportPathForLicense(getAuthCookie("licenseType") || "", id);

  if (typeof window !== "undefined") {
    window.location.replace(target);
  }

  return null;
}
